module.exports = __webpack_public_path__ + "img/logo-text-white.ee45e070.svg";